/**
 * created by lei lei on 2020/5/28
 * 活动待处理组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon,Row,Col, Popconfirm,} from "antd";
import activity from './img/u210.png'
import topic from './img/u210.png'
export default class ActivityPending extends Component {
    static defaultProps = {
        showPoint:true,
        pointColor:'red',
        customWidth:250,
        showX:false,
        iconType:1,
        statusMarkStatus:true,
        statusMark:'请放入字段'
    }
    static propTypes = {
        title: PropTypes.string.isRequired, //标题
        //icon : PropTypes.string, //图标
        content:PropTypes.string.isRequired,//内容
        statusMark:PropTypes.string.isRequired,//描述
        timeMark:PropTypes.string.isRequired,//描述
        showPoint:PropTypes.bool,//是否显示点
        pointColor:PropTypes.string,//红点的颜色
        onClickItem:PropTypes.func,//点击每一项
        customWidth:PropTypes.number,//自定义宽度自适应页面的时候自己给宽度适应
        showX:PropTypes.bool,//是否显示X
        onRemoveItem:PropTypes.func,//点击删除
    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    onRemoveItem(){
        this.props.onRemoveItem&&this.props.onRemoveItem()
    }
    render() {
        let img
        if(this.props.iconType===1){
            img= <img src={activity} style={{width:25,height:25}}/>
        } else{
            img= <img src={topic} style={{width:25,height:25}}/>
        }
        return (
            <div className={'ActivityPending'} style={{border:'1px solid #ebebeb',position:'relative', margin: "5px"}} >
                {this.props.showX?
                    <Popconfirm style={{position:'relative'}} onConfirm={()=>this.onRemoveItem()}  title="是否忽略此提醒" okText="确认" cancelText="取消">
                    <div style={{width:20,height:20,position:'absolute',right:7,top:7,cursor:'pointer'}}>
                        <Icon type="close" />
                </div></Popconfirm>
                    :null}


                <div onClick={()=>{this.props.onClickItem()}} style={{width:this.props.customWidth,height:150,background:'white',padding:20,cursor: 'pointer'}}>
                    <div style={{display:'-webkit-inline-box',height:25,lineHeight:'25px'}}>
                        <div style={{width:25,height:25,borderRadius:'50%'}}>
                            {img}

                        </div>
                        <div title={this.props.title} style={{marginLeft:10,fontSize:13,fontFamily:'Arial Normal,Arial',fontWeight:'bold',padding:5,width:125,
                            overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{this.props.title}</div>
                    </div>
                    <div  title={this.props.content} style={{height:36,marginTop:15,fontSize:12,color:'#8f949a',width:150,
                        overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{this.props.content}</div>
                    <Row>
                        <Col span={18}>
                            {this.props.showPoint? <div style={{width:8,height:8,background:'red',borderRadius:'50%',marginTop:7,float:'left'}}></div>:null}
                          <div title={this.props.statusMark} style={{height:20,lineHeight:'20px',fontSize:12,color:'#8f949a',marginLeft:10,float:'left',width:85, overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{this.props.statusMark}</div>
                        </Col>
                        <Col span={6}>
                            <div style={{width:100,height:20,lineHeight:'20px',fontSize:12,color:'#0000003e',}}>{this.props.timeMark}</div>
                        </Col>
                    </Row>
                    {/*<div  style={{height:20,marginTop:0,float:'left'}}>




                    </div>*/}
                </div>
            </div>
           /* <Row  gutter={24}  style={{border:'1px solid #ebebeb'}} onClick={()=>{this.props.onClickItem()}}>
                <div style={{height:150,width:260,background:'white',padding:20,cursor: 'pointer'}}>
                    <Col span={24}>
                        <Col span={4}>
                            <div style={{width:25,height:25,lineHeight:'25px',background:'red',borderRadius:'50%',textAlign:'center'}}>
                                <Icon type="mail" />
                            </div>

                        </Col>
                        <Col span={20}>
                            <div style={{fontSize:13,fontFamily:'Arial Normal,Arial',fontWeight:'bold'}}>{this.props.title}</div>

                        </Col>

                    </Col>

                    <Col span={24}>
                        <div style={{height:36,marginTop:10,fontSize:12,color:'#8f949a'}}>{this.props.content}</div>
                    </Col>
                    <div  style={{display:'-webkit-inline-box',height:20,marginTop:25}}>
                        <div style={{width:8,height:8,background:this.props.pointColor,borderRadius:'50%',marginTop:7,marginLeft:10}}/>
                        <div style={{height:20,lineHeight:'20px',fontSize:12,color:'#8f949a',marginLeft:10}}>{this.props.statusMark}</div>
                        <div style={{height:20,lineHeight:'20px',fontSize:12,color:'#0000003e',marginLeft:85}}>{this.props.timeMark}</div>
                    </div>



                </div>
            </Row>*/
        )
    }

}